module.exports = __webpack_public_path__ + "img/axilar.600ce9f4.png";